import { render, staticRenderFns } from "./record-list.vue?vue&type=template&id=507ddad0&"
import script from "./record-list.vue?vue&type=script&lang=js&"
export * from "./record-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports